import { Option } from 'modules/legal_entities/pages/settings/ContractsLegalEntityPage/ContractFields/types'

const ActionType = {
  delete: 'delete',
  edit: 'edit',
  archive: 'archive',
}

export const updateOptions = (
  options: Option[],
  action: keyof typeof ActionType,
  index: number,
  value?: string
): Option[] => {
  const newOptions = [...options]
  const option = newOptions.find((x) => x.id === String(index)) || newOptions[index]
  if (!option) return newOptions

  switch (action) {
    case ActionType.delete:
      newOptions.splice(index, 1)
      break
    case ActionType.edit:
      if (value) {
        option.label = value
      }
      break
    case ActionType.archive:
      option.isActive = !option.isActive
      break
    default:
      return newOptions
  }
  return newOptions
}
